export default class IndexedDB {
    constructor() {
        this.IDB_NAME = "veriftechidb";
        this.csrfToken = "";
    }
    async initDB() {
        this.db = await new Promise((resolve, reject) => {
            const request = indexedDB.open(this.IDB_NAME, 1);
            request.onerror = () => reject(request.error);
            request.onupgradeneeded = () => {
                const db = request.result;
                if (!db.objectStoreNames.contains("config")) {
                    db.createObjectStore("config");
                }
            };
            request.onsuccess = () => resolve(request.result);
        });
        const csrfTokenMetaTag = document.querySelector("[name=csrf-token]");
        this.csrfToken = csrfTokenMetaTag.content;
        // this.db is initialized, save or create a new user with guest_id
        const guestID = await this.getValue("config", "guest_id");
        if (!guestID) {
            const guestID = this.generateGuestID();
            await this.saveValue("config", "guest_id", guestID);
        }
    }
    generateGuestID() {
        const datenow = Date.now().toString(16);
        const random = Math.random().toString(36).substring(2);
        return `${datenow}-${random}${random}`;
    }
    async saveValue(store, key, value) {
        if (!this.db) {
            console.warn("DB not initialized");
            return;
        }
        return new Promise((resolve, reject) => {
            const transaction = this.db.transaction(store, "readwrite");
            const objectStore = transaction.objectStore(store);
            const request = objectStore.put(value, key);
            request.onsuccess = () => resolve();
            request.onerror = () => reject(request.error);
        });
    }
    async getValue(store, key) {
        if (!this.db) {
            console.warn("DB not initialized");
            return null;
        }
        return new Promise((resolve, reject) => {
            const transaction = this.db.transaction(store, "readonly");
            const objectStore = transaction.objectStore(store);
            const request = objectStore.get(key);
            request.onsuccess = () => resolve(request.result);
            request.onerror = () => reject(request.error);
        });
    }
}
